import { api } from "./client";
import type { PremiumStatus } from "../types";

export const premiumApi = {
  getStatus: () => api.get<PremiumStatus>("/premium/status"),

  subscribeVip: () =>
    api.post<{ message: string; premium: PremiumStatus; diamonds_spent: number; chest_rewards?: Record<string, number> }>(
      "/premium/vip/subscribe",
      {},
    ),

  activatePro: () =>
    api.post<{ message: string; premium: PremiumStatus; diamonds_spent: number }>("/premium/pro/activate", {}),

  claimWeeklyChest: () =>
    api.post<{ message: string; rewards: Record<string, number>; premium: PremiumStatus }>(
      "/premium/vip/claim-weekly-chest",
      {},
    ),

  getAlchemyShop: () =>
    api.get<{
      packs: { diamonds: number; gold: number }[];
      min_vip_level: number;
      vip_level: number;
      subscription_active: boolean;
    }>("/premium/shop/alchemy"),

  buyAlchemyPack: (packIndex: number) =>
    api.post<{ message: string; gold_gained: number; diamonds_spent: number; remaining_diamonds: number }>(
      `/premium/shop/alchemy/${packIndex}`,
      {},
    ),
};
